import React, { useRef, useEffect, useState, useMemo, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import _ from 'lodash'
import styles from './SettingAccountView.module.scss'
import MainLayout from '../MainLayout'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import ListHistoryComponent from '../../components/ListHistory'
import ListAccountComponent from '../../components/ListAccount'
import moment from 'moment'
import ButtonComponent from '../../components/Button'
import types from '../../constants/types'
import Loading from '../../components/Loading'
import Autocomplete from '@material-ui/lab/Autocomplete'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import cn from 'classnames'
import Checkbox from '@material-ui/core/Checkbox'
import Tour from 'reactour'
import { getIsGuideByKey, GUIDE_TYPE_ENUM, setIsGuideByKey } from 'utils/helper'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectCountries,
  selectCountriesOnly,
  selectGuideListByKey,
} from 'stores/config/config.selector'
import { useTranslation } from 'react-i18next'
import DialogPolicyPointContainer from '../DialogPolicyPoint'
import { accountApi } from '../../api/accountApi'
import { showError, showSuccess } from '../../stores/alert/slice.alert'
import { IconButton, Tooltip, Typography } from '@material-ui/core'
import ModalConfirm from 'components/Modals/ModalConfirm'
import MessengerButton from '../Home/items/MessengerButton'
import {
  MISSION_LABEL_KEYS,
  getMappedMissions,
} from '../DialogPolicyPoint/missionHelpers'

const useStyles = makeStyles((theme) => ({
  wrapInfo: {
    display: "grid",
    gridTemplateColumns: "calc(50% - 30px) 50%",
    gap: "15px",
    width: "100%",
    alignItems: "stretch" 
  },
  left: {
    display: "flex",
    flexDirection: "column",
    margin: "15px 0px"
  },
  right: {
    display: "flex",
    flexDirection: "column",
    margin: "15px 0px"
  },

  textField: {
    margin: "12px 5px",
    width: "calc(100% - 10px)",
    float: "left"
  },
  textFieldFirst: {
    margin: "14px 5px",
    width: "calc(50% - 10px)"
  },
  form: {
    display: "inline-block"
  },
  box: {
    background: "white",
    padding: "15px",
    borderRadius: "12px",
    border: "1px solid #efefef",
    // boxShadow: "0 0 2rem 0 rgba(136,152,170,.15)!important",
    height: "100%", // Ensure the box takes full height
    display: "flex", // Use flexbox to allow for vertical alignment of content
    flexDirection: "column", // Stack children vertically
    "& h4": {
      marginTop: 0,
      color: "#02A351"
    }
  },
  
  wrapAvatar: {
    textAlign: "center"
  },
  avatar: {
    margin: "0px auto",
    marginBottom: 5,
    width: 120,
    height: 120,
    fontSize: "60px"
  },
  giftPoint: {
    marginTop: "12px"
  },
  viewPolicyPoint: {
    color: "rgb(255, 128, 0)",
    cursor: "pointer",
    textDecoration: "underline overline",
    "&:hover": {
      color: "#618833"
    }
  },
  wrapPolicyPoint: {
    textAlign: "center",
    padding: "0px 15px",
    marginBottom: "20px",
    "& h4": {
      marginBottom: 0,
      padding: 0,
      color: "#05AE34"
    },
    "& h6": {
      marginTop: 5,
      fontSize: 14,
      color: "red"
    }
  },
  time: {
    margin: "12px 0px 12px 0px",
    "& span": {
      fontWeight: "bold"
    }
  },
  buttonChange: {
    marginLeft: 5
  },
  service: {
    display: "flex",
    width: "100%",
    padding: 0,
    "& li": {
      padding: 15,
      listStyle: "none",
      width: "33.333%",
      border: "1px solid #f0f0f0",
      "& span": {
        fontWeight: "bold",
        color: "#05AE34"
      }
    }
  },
  history: {
    width: "100%",
    "& h4": {
      marginBottom: 5,
      color: "#05AE34"
    }
  },
  accounts: {
    width: "100%",
    "& h4": {
      marginBottom: 5,
      color: "#05AE34"
    }
  },
  titleChangePassword: {
    textAlign: "center"
  },
  formChangePassword: {
    padding: "0px 10px 10px 10px",
    textAlign: "center",
    display: "inline-block",
    width: "100%",
    "& .MuiTextField-root": {
      margin: "0px 5px"
    },
    "& .MuiFormControl-root": {
      display: "inline-block",
      width: "calc(100% - 30px)",
      margin: 5
    }
  },
  changePasswordButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    marginBottom: 10
  },
  wrapTextareaCopy: {
    textAlign: "center",
    marginBottom: 30,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  changePasswordSucc: {
    color: "#05AE34"
  },
  changePasswordErr: {
    color: "red"
  },
  changePasswordStatus: {
    marginTop: 0
  },
  textarea: {
    width: "70%",
    minHeight: 60,
    marginRight: 15,
    padding: 5,
    borderColor: "#ddd",
    resize: "none"
  },
  copySuccess: {
    textAlign: "center",
    color: "#05AE34"
  },
  errorInput: {
    "& .MuiFilledInput-root": {
      border: "1px solid red"
    }
  },
  error: {
    color: "red",
    position: "absolute",
    bottom: "-15px",
    fontSize: "14px",
    left: "5px"
  },
  wrapAutocomplete: {
    display: "inline-block",
    width: "calc(100% - 10px)",
    margin: "12px 5px"
  },
  col6: {
    width: "50%",
    display: "inline-block",
    position: "relative"
  },
  col12: {
    width: "526px",
    display: "inline-block",
    position: "relative"
  },
  wrapButtonChange: {
    textAlign: "right",
    marginTop: 15
  },
  success: {
    textAlign: "center",
    color: "#05AE34"
  },
  error: {
    color: "red",
    marginLeft: "6px"
  },
  copyButton: {
    padding: 4,
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)"
    }
  }
}));
const SettingAccountView = (props) => {
  const {
    user,
    onWhatYouNeed,
    onDashboard,
    share,
    dashboard,
    onSubmitChangePassword,
    changePassword,
    onChangePasswordStatus,
    whatYouNeed,
    onGetInviteCode,
    inviteCode,
    onUnlink,
    unlink,
    loading,
    updateUser,
    messageUnlink,
    messageInviteError,
    onGetUser,
    missions,
    missionPoints,
    onGetRewardMissions,
  } = props
    console.log("🚀 ~ SettingAccountView ~ user:", user)
  const classes = useStyles()
  const history = useHistory()
  const [passwordOld, setPasswordOld] = useState('')
  const [passwordNew, setPasswordNew] = useState('')
  const [passwordNew2, setPasswordNew2] = useState('')
  const [showPwOld, setShowPwOld] = useState(false);
  const [showPwNew, setShowPwNew] = useState(false);
  const [showPwNew2, setShowPwNew2] = useState(false);

  const passwordStrength = useMemo(() => {
    let score = 0;
    const v = passwordNew || '';
    if (v.length >= 8) score++;
    if (/[A-Z]/.test(v) && /[0-9]/.test(v)) score++;
    if (/[^A-Za-z0-9]/.test(v) && v.length >= 10) score++;
    return score;
  }, [passwordNew]);

  const strengthClasses = ['', styles.onweak, styles.onmid, styles.onstrong];

  const [isChangePassword, setIsChangePassword] = useState(false)
  const [isChangePasswordSucss, setIsChangePasswordSucss] = useState(null)
  const [isViewPolicyPoint, setIsViewPolicyPoint] = useState(false)
  const [isSnackbar, setIsSnackbar] = useState(false)
  const [copySuccess, setCopySuccess] = useState('')
  const textAreaRef = useRef(null)
  const [inviteCodeData, setInviteCodeData] = useState('')
  const [errorPassword, setErrorPassword] = useState('')
  const [isInviteCodePopup, setIsInviteCodePopup] = useState(false)
  const [isSubmitChangePassword, setIsSubmitChangePassword] = useState(false)
  const [nameError, setNameError] = useState('')
  const [phoneError, setPhoneError] = useState('')
  const [emailError, setEmailError] = useState('')
  const [countryError, setCountryError] = useState('')
  // const [proviceError, setProviceError] = useState("");
  const [name, setName] = useState('')
  const [phone, setPhone] = useState('')
  const [email, setEmail] = useState('')
  const [company, setCompany] = useState('')
  const [getOpenPoits, setGetOpenPoits] = useState(0)

  const [business, setBusiness] = useState([])
  const [province, setProvince] = useState([])
  const [updateInfoError, setUpdateInfoError] = useState('')
  const [updateInfoSuccess, setUpdateInfoSuccess] = useState('')
  const tourOverview = useSelector(
    selectGuideListByKey(GUIDE_TYPE_ENUM.account_manager)
  )
  const [tourConfig, setTourConfig] = useState(null)
  const { t, i18n } = useTranslation()
  const locale = i18n.language?.startsWith('en') ? 'en-US' : 'vi-VN'
  const TRANSFER_KEYWORD = t('setting_account.transfer_confirm_keyword')

  const strengthLabels = [
    t('setting_account.pw_strength_label'),
    t('setting_account.pw_strength_weak'),
    t('setting_account.pw_strength_medium'),
    t('setting_account.pw_strength_strong'),
  ];

  const countries = useSelector(selectCountries)
  const countriesOnly = useSelector(selectCountriesOnly)

  const [country, setCountry] = useState()

  const [isOpenTransfer, setIsOpenTransfer] = useState(false)

  const [isShowConfirmTransfer, setIsShowConfirmTransfer] = useState(false)

  const [transferedId, setTransferedId] = useState('')

  const [copied, setCopied] = useState(false)
  const [businessInput, setBusinessInput] = useState('')
  const [confirmTransferText, setConfirmTransferText] = useState('')
  const [activeTab, setActiveTab] = useState('profile')
  const [isVersionPopup, setIsVersionPopup] = useState(false)
  const [isRewardsPopup, setIsRewardsPopup] = useState(false)
  const [rewardSubTab, setRewardSubTab] = useState('missions')

  useEffect(() => {
    if (isRewardsPopup) {
      onGetRewardMissions()
    }
  }, [isRewardsPopup])

  const dispatch = useDispatch()

  const handleCopy = useCallback((id) => {
    navigator.clipboard.writeText(id).then(() => {
      setCopied(true)
      dispatch(showSuccess(`Đã sao chép: ${id}`))
      setTimeout(() => setCopied(false), 2000)
    })
  }, [dispatch])

  useEffect(() => {
    if (
      getIsGuideByKey(GUIDE_TYPE_ENUM.account_manager) &&
      tourOverview?.length
    ) {
      console.log('[SettingAccountView] tour account_manager steps RAW:', JSON.stringify(tourOverview))
      // Override selector + content để khớp với 5 TAB BUTTONS
      const stepOverrides = {
        // Tab 1: Hồ sơ
        '#info_account':     { selector: '#info_account',     content: t('setting_account.tour_info'), order: 1 },
        '#info-account':     { selector: '#info_account',     content: t('setting_account.tour_info'), order: 1 },
        '#profile':          { selector: '#info_account',     content: t('setting_account.tour_info'), order: 1 },
        
        // Tab 2: Tài khoản liên kết
        '#add_account':      { selector: '#add_acount',       content: t('setting_account.tour_linked'), order: 2 },
        '#add_acount':       { selector: '#add_acount',       content: t('setting_account.tour_linked'), order: 2 },
        '#add-account':      { selector: '#add_acount',       content: t('setting_account.tour_linked'), order: 2 },
        '#linked':           { selector: '#add_acount',       content: t('setting_account.tour_linked'), order: 2 },
        
        // Tab 3: Gói & giao dịch
        '#order_history':    { selector: '#order_history',    content: t('setting_account.tour_billing'), order: 3 },
        '#order-history':    { selector: '#order_history',    content: t('setting_account.tour_billing'), order: 3 },
        '#billing':          { selector: '#order_history',    content: t('setting_account.tour_billing'), order: 3 },
        
        // Tab 4: Điểm thưởng (backend gửi #disconnect)
        '#disconnect':       { selector: '#rewards_points',   content: t('setting_account.tour_rewards'), order: 4 },
        '#rewards_points':   { selector: '#rewards_points',   content: t('setting_account.tour_rewards'), order: 4 },
        '#rewards':          { selector: '#rewards_points',   content: t('setting_account.tour_rewards'), order: 4 },
        '#gift_point':       { selector: '#rewards_points',   content: t('setting_account.tour_rewards'), order: 4 },
        
        // Tab 5: Bảo mật
        '#change_password':  { selector: '#change_password',  content: t('setting_account.tour_password'), order: 5 },
        '#change-password':  { selector: '#change_password',  content: t('setting_account.tour_password'), order: 5 },
        '#security':         { selector: '#change_password',  content: t('setting_account.tour_password'), order: 5 },
      }
      
      const mappedSteps = tourOverview.map((step) => {
        const override = stepOverrides[step.selector]
        if (override) {
          console.log(`[SettingAccountView] Override step: ${step.selector} → ${override.selector}`, override)
          return { ...step, ...override }
        }
        console.log(`[SettingAccountView] Keep original step:`, step.selector)
        return step
      })
      
      // Sắp xếp lại theo thứ tự tab: Hồ sơ → Tài khoản liên kết → Gói & giao dịch → Điểm thưởng → Bảo mật
      const sortedSteps = mappedSteps.sort((a, b) => (a.order || 999) - (b.order || 999))
      
      console.log('[SettingAccountView] tour account_manager steps SORTED:', JSON.stringify(sortedSteps))
      setTourConfig(sortedSteps)
      setIsGuideByKey(GUIDE_TYPE_ENUM.account_manager)
    }
  }, [tourOverview])

  useEffect(() => {
    setName(user && user.name)
    setEmail(user && user.email)
    if (user && user.phone) {
      setPhone(user && user.phone)
    }
    setCompany(user.company)
    setCountry(user?.country)
    setProvince(user?.province)

    if (whatYouNeed?.business && user?.business) {
      let businessList = _.toString(user.business).split(',')
      const data = businessList?.map((b) => {
        return whatYouNeed.business.find((bus) => _.toString(bus.id) === _.toString(b))
      }).filter(Boolean)
      // console.log(data);
      setBusiness(data)
    }

    // console.log('user ===>', user)
  }, [whatYouNeed, user])
  useEffect(() => {
    if (unlink) {
      const params = {
        fields: 'user,users,package,history,version,versions,business,province',
      }
      onWhatYouNeed(params)
    }
  }, [unlink])

  useEffect(() => {
    const searchParam = new URLSearchParams(window.location.search)
    if (searchParam && searchParam.get('openPoits')) {
      setGetOpenPoits(searchParam.get('openPoits'))
      setActiveTab('rewards')
      setRewardSubTab('redeem')
    }

    const params = {
      fields: 'user,users,package,history,version,versions,business,province',
    }
    onWhatYouNeed(params)
    onDashboard()
  }, [])

  useEffect(() => {
    if (changePassword === true) {
      // Thành công — clear form và hiện toast
      setPasswordOld('')
      setPasswordNew('')
      setPasswordNew2('')
      setIsSubmitChangePassword(false)
      dispatch(showSuccess(t('noti.change_password')))
    } else if (changePassword === false) {
      // Thất bại — hiện lỗi inline
      dispatch(showError(t('noti.password_invalid')))
    }
    setIsChangePasswordSucss(changePassword)
  }, [changePassword])

  useEffect(() => {
    if (inviteCode) {
      setInviteCodeData(
        `${window.location.origin}/invite-code?ref=invite-code&code=${
          inviteCode && inviteCode.code
        }`
      )
    }
  }, [inviteCode])

  const handleChangePassword = (key, value) => {
    switch (key) {
      case 'passwordOld':
        setPasswordOld(value)
        break
      case 'passwordNew':
        setPasswordNew(value)
        break
      case 'passwordNew2':
        setPasswordNew2(value)
        break
      default:
        break
    }
  }

  const handleSubmitChangePassword = () => {
    setIsSubmitChangePassword(true)
    if (!_.isEmpty(passwordNew) && !_.isEmpty(passwordNew2)) {
      if (!user.noPwSet && _.isEmpty(passwordOld)) {
        setErrorPassword(t('noti.reset_password_invalid'))
      } else {
        if (passwordNew !== passwordNew2) {
          setErrorPassword(t('noti.new_password_invalid'))
        } else {
          setErrorPassword('')
          onSubmitChangePassword({ passwordOld, passwordNew })
          // setPasswordOld("");
          // setPasswordNew("");
          // setPasswordNew2("");
        }
      }
    } else {
      setErrorPassword(t('noti.reset_password_invalid'))
    }
  }

  const handleOpenIsViewPolicyPoint = () => {
    setIsViewPolicyPoint(true)
  }

  const handleCloseIsViewPolicyPoint = () => {
    setGetOpenPoits(0)
    setIsViewPolicyPoint(false)
    const params = {
      fields: 'user,users,package,history,version,versions,business,province',
    }
    onWhatYouNeed(params)
  }

  const handleOpenChangePassword = () => {
    setIsSubmitChangePassword(false)
    setErrorPassword(null)
    setIsChangePassword(true)
  }

  const handleCloseChangePassword = () => {
    setIsChangePassword(false)
    setPasswordOld('')
    setPasswordNew('')
    setPasswordNew2('')
    onChangePasswordStatus(null)
  }

  const handleCloseInviteCodePopup = () => {
    setIsInviteCodePopup(false)
  }

  const handleSubmitInviteCode = () => {
    onGetInviteCode()
    setIsInviteCodePopup(true)
  }
  const copyToClipboard = (e) => {
    textAreaRef.current.select()
    document.execCommand('copy')
    setCopySuccess(t('noti.invite_account'))
  }
  const handleClosePoup = () => {
    setIsChangePassword(false)
  }
  const handleUnlink = async (item) => {
    await onUnlink(item)
    await onGetUser(user.id)
  }
  const handleChange = (key, value) => {
    switch (key) {
      case 'name':
        setName(value)
        break
      case 'phone':
        setPhone(value)
        break
      case 'email':
        setEmail(value)
        break
      case 'company':
        setCompany(value)
        break
      case 'province':
        setProvince(value)
        break
      case 'business':
        setBusiness(value)
        break
      case 'country':
        setCountry(value)
        setProvince('')
        break

      default:
        break
    }
  }
  const handleSubmitChangeInfo = () => {
    if (validate()) {
      const data = {
        name,
        phone,
        email,
        company,
        business: business ? business?.map((v) => v.id) : [],
        country,
        province,
      }
      updateUser(data, user.id).then((res) => {
        if (res && res.id) {
          setUpdateInfoError('')
          setUpdateInfoSuccess(t('noti.update_info'))
        } else {
          setUpdateInfoSuccess('')
          setUpdateInfoError(t('noti.update_info_fail'))
        }
      })
    }
  }
  const providerOptions = useMemo(() => {
    if (country) {
      const countrySelected = countries.find((c) => c.countryName === country)
      if (countrySelected) return countrySelected?.provinces
    }
  }, [country, countries])

  const validate = () => {
    setNameError('')
    setPhoneError('')
    setEmailError('')
    let isValid = true
    if (!name || name.length <= 2) {
      isValid = false
      setNameError(t('noti.name_incorrect'))
    }
    if (!email) {
      isValid = false
      setEmailError(t('noti.email'))
    }

    if (email) {
      const pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
      )
      if (!pattern.test(email)) {
        isValid = false
        setEmailError(t('noti.email_incorrect'))
      }
    }

    if (!phone) {
      isValid = false
      setPhoneError(t('noti.phone'))
    }

    if (phone) {
      if (!phone?.trim() || phone.length < 5 || phone.length > 20) {
        isValid = false
        setPhoneError(t('noti.phone_incorrect'))
      }
    }
    if (!country) {
      isValid = false
      setCountryError(t('update.country_incorrect'))
    } else {
      setCountryError('')
    }
    // if (country && !province) {
    //   isValid = false;
    //   setProviceError(t("update.province_incorrect"));
    // } else {
    //   setCountryError("");
    // }

    return isValid
  }

  let user_business = []
  if (business) {
    user_business = business.filter((b) => b != null)
  }

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
  const checkedIcon = <CheckBoxIcon fontSize="small" />
  const closeTour = () => setTourConfig(null)

  const handleTransferAccount = async () => {
    try {
      if (!transferedId.trim()) {
        dispatch(showError(t('setting_account.transfer_enter_id_error')))
        return
      }

      const payload = {
        mainUserId: user.id,
        linkedUserId: transferedId,
      }
      const res = await accountApi.transferToAccount(payload)

      dispatch(
        showSuccess(
          t('setting_account.transfer_success', { from: user.id, to: res.id })
        )
      )

      setIsShowConfirmTransfer(false)
      setIsOpenTransfer(false)

      setTimeout(() => {
        window.location.reload()
      }, 2000)

      await onGetUser(user.id)
    } catch (error) {
      dispatch(showError(error.message))
    }
  }

  // Tìm thông tin tài khoản đích dựa trên transferedId
  const transferedAccount = useMemo(() => {
    return whatYouNeed?.users?.find(u => u.id === transferedId);
  }, [whatYouNeed, transferedId]);

  // Chuẩn bị chuỗi hiển thị: "Tên (ID)"
  const transferedDisplay = transferedAccount 
    ? `${transferedAccount.name} (${transferedAccount.id})` 
    : transferedId;

  const currentUserDisplay = `${user.name} (${user.id})`;

  
  const isDirty = name !== user?.name
    || phone !== user?.phone
    || email !== user?.email
    || company !== user?.company
    || country !== user?.country
    || province !== user?.province
    || JSON.stringify((business || []).filter(Boolean).map(b => b?.id).sort()) !== JSON.stringify(
        (_.toString(user?.business || '').split(',').filter(Boolean)).sort()
      );

  // avatar color helper
  const avatarColor = (str) => {
    const colors = ['#22C55E','#3B82F6','#8B5CF6','#F59E0B','#EF4444','#06B6D4'];
    let h = 0; for (let i = 0; i < (str||'').length; i++) h = str.charCodeAt(i) + ((h << 5) - h);
    return colors[Math.abs(h) % colors.length];
  };

  // ── Stats từ API thực ──────────────────────────────────────────────────────
  // dashboard.info: giftPoint, totalMes (tin còn lại), expiredAt, type, numRef
  // dashboard.fanpage: totalSent, totalSuccess, totalFail (tin đã gửi)
  // whatYouNeed.package: messageLimit, name, expiredAt
  const accountInfo = dashboard?.info || {}
  const totalMesRemain = accountInfo.totalMes
  const isUnlimitedMsgs = totalMesRemain > 1000000000 || totalMesRemain === -1
  // Tin đã gửi: lấy từ dashboard.fanpage.totalSent (giống DashboardV2)
  const fanpageStats = dashboard?.fanpage || {}
  const messageSentCalc = (() => {
    if (fanpageStats.totalSent != null) return fanpageStats.totalSent
    const s = fanpageStats.totalSuccess ?? 0
    const f = fanpageStats.totalFail ?? 0
    if (s || f) return s + f
    return user?.message_sent || 0
  })()
  const packageMsgLimit = whatYouNeed?.package?.messageLimit
  // Điểm thưởng: ưu tiên whatYouNeed.package.giftPoint → dashboard.info.giftPoint
  const giftPointDisplay = whatYouNeed?.package?.giftPoint ?? accountInfo.giftPoint ?? user?.point ?? 0
  const rewardsMissionPoints = missionPoints !== null ? missionPoints : giftPointDisplay
  // Badge gói dịch vụ
  const packageName = (typeof (whatYouNeed?.package?.name) === 'string' ? whatYouNeed.package.name : null)
    || (typeof user?.package_name === 'string' ? user.package_name : null)
    || t('overall.account_info.lifetime')

  return (
    <MainLayout>
      <Tour
        steps={tourConfig}
        isOpen={tourConfig != null}
        closeWithMask={false}
        lastStepNextButton={
          <Button size="small" className="btn--rounder" variant="contained">
            {t("common.btn.close")}
          </Button>
        }
        accentColor="#05ae34"
        onRequestClose={closeTour}
      />
      {loading && <Loading />}

      <div className={styles.main}>
        {/* ── PAGE HEAD ── */}
        <div className={styles.pageHead}>
          <div className={styles.pageTitle}>{t('setting_account.page_title')}</div>
          <div className={styles.pageSub}>{t('setting_account.page_sub')}</div>
        </div>

        {/* ── PROFILE HERO ── */}
        <div className={styles.profileHero}>
          <div className={styles.heroAvatar} style={{background: avatarColor(user?.name)}}>
            {user?.name ? user.name.charAt(0).toUpperCase() : 'U'}
          </div>
          <div className={styles.heroInfo}>
            <div className={styles.heroNameRow}>
              <span className={styles.heroName}>{user?.name || ''}</span>
              {(!user?.usedWithUserId) && <span className={styles.badgeRole}>{t('setting_account.badge_main_account')}</span>}
              <span className={styles.badgePlan}>{packageName}</span>
            </div>
            <div className={styles.heroMeta}>
              <span>{user?.email}</span>
              <span className={styles.dotSep} />
              <span className={styles.heroId}>ID {user?.id}</span>
              <button className={styles.copyBtn} onClick={() => handleCopy(user?.id)} title={t('setting_account.copy_id_tooltip')}>
                <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.2"><rect x="3" y="3" width="7" height="7" rx="1"/><path d="M2 8V2h6"/></svg>
              </button>
            </div>
          </div>
          <div className={styles.heroStats}>
            <div className={styles.heroStat}>
              <div className={styles.heroStatVal}>{messageSentCalc.toLocaleString(locale)}</div>
              <div className={styles.heroStatLbl}>{t('setting_account.stat_sent')}</div>
            </div>
            <div className={styles.heroStat}>
              <div className={`${styles.heroStatVal} ${styles.inf}`}>{isUnlimitedMsgs ? '∞' : (totalMesRemain ?? 0).toLocaleString(locale)}</div>
              <div className={styles.heroStatLbl}>{t('setting_account.stat_remain')}</div>
            </div>
            <div
              className={styles.heroStat}
              style={{cursor: 'pointer'}}
              onClick={() => {
                setActiveTab('rewards')
                if (Number(rewardsMissionPoints) >= 200) {
                  setIsRewardsPopup(true)
                }
              }}
              title={t('setting_account.rewards_popup_open')}
            >
              <div className={styles.heroStatVal} style={{color: 'var(--green-dark)'}}>{giftPointDisplay} ✦</div>
              <div className={styles.heroStatLbl}>{t('setting_account.stat_points')}</div>
            </div>
          </div>
        </div>

        {/* TABS */}
        <div className={styles.tabsBar}>
          <button id="info_account" className={activeTab === 'profile' ? styles.tabBtn + ' ' + styles.active : styles.tabBtn} onClick={() => setActiveTab('profile')}>
            <svg viewBox="0 0 15 15"><circle cx="7.5" cy="5" r="2.5"/><path d="M2.5 13.5c0-2.8 2.2-4.5 5-4.5s5 1.7 5 4.5"/></svg>
            {t('setting_account.tab_profile')}
          </button>
          <button id="add_acount" className={activeTab === 'linked' ? styles.tabBtn + ' ' + styles.active : styles.tabBtn} onClick={() => setActiveTab('linked')}>
            <svg viewBox="0 0 15 15"><circle cx="5.5" cy="5" r="2.3"/><path d="M1.5 12.5c0-2.3 1.8-3.8 4-3.8s4 1.5 4 3.8"/><path d="M10 2a2.3 2.3 0 010 4.6M13.5 12.5c0-1.9-1.2-3.3-2.8-3.7"/></svg>
            {t('setting_account.tab_linked')} <span className={styles.tabCount}>{whatYouNeed?.users?.length || 0}</span>
          </button>
          <button id="order_history" className={activeTab === 'billing' ? styles.tabBtn + ' ' + styles.active : styles.tabBtn} onClick={() => setActiveTab('billing')}>
            <svg viewBox="0 0 15 15"><rect x="1.5" y="3" width="12" height="9" rx="1.5"/><path d="M1.5 6h12M4 9.5h3"/></svg>
            {t('setting_account.tab_billing')}
          </button>
          <button
            id="rewards_points"
            className={activeTab === 'rewards' ? styles.tabBtn + ' ' + styles.active : styles.tabBtn}
            onClick={() => {
              setActiveTab('rewards')
              if (Number(rewardsMissionPoints) >= 200) {
                setIsRewardsPopup(true)
              }
            }}
          >
            <svg viewBox="0 0 15 15"><rect x="2" y="6" width="11" height="7" rx="1"/><path d="M7.5 6v7M2 8.5h11M4.5 6C3.4 6 2.5 5.1 2.5 4S3.4 2 4.5 2c1.6 0 3 2 3 4M10.5 6c1.1 0 2-.9 2-2s-.9-2-2-2-1.6 0-3 2-3 4"/></svg>
            {t('setting_account.tab_rewards')} <span className={styles.tabCount}>{giftPointDisplay}</span>
          </button>
          <button id="change_password" className={activeTab === 'security' ? styles.tabBtn + ' ' + styles.active : styles.tabBtn} onClick={() => setActiveTab('security')}>
            <svg viewBox="0 0 15 15"><path d="M7.5 1.5l5 2v3.5c0 3.2-2.1 5.6-5 6.5-2.9-.9-5-3.3-5-6.5V3.5l5-2z"/><path d="M5.5 7.5l1.5 1.5 2.5-3"/></svg>
            {t('setting_account.tab_security')}
          </button>
        </div>

        {/* TAB 1: HỒ SƠ */}
        {activeTab === 'profile' && (
          <section className={styles.tabPanel} id="panel-profile">
            <div className={styles.card}>
              <div className={styles.cardHd}>
                <div>
                  <div className={styles.cardHdTitle}>{t('setting_account.profile_card_title')}</div>
                  <div className={styles.cardHdSub}>{t('setting_account.profile_card_sub')}</div>
                </div>
              </div>
              <div className={styles.cardBd}>
                <div className={styles.formGrid}>
                  <div className={styles.formField}>
                    <label className={styles.fieldLabel}>{t('setting_account.field_account_id')}</label>
                    <div className={styles.inputWrap}>
                      <input className={styles.input} value={user?.id || ""} readOnly />
                      <button className={styles.inputIconBtn} onClick={(e) => { e.stopPropagation(); handleCopy(user?.id); }} title={t('setting_account.field_copy_tooltip')}>
                        <svg viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.3"><rect x="4" y="4" width="8" height="8" rx="1"/><path d="M2.5 9.5v-7h7"/></svg>
                      </button>
                    </div>
                    <span className={styles.fieldHint}>{t('setting_account.field_id_hint')}</span>
                  </div>
                  
                  <div className={styles.formField}>
                    <label className={styles.fieldLabel}>{t('setting_account.field_phone')}</label>
                    <input className={styles.input} value={phone || ""} onChange={(e) => handleChange("phone", e.target.value)} />
                    {!_.isEmpty(phoneError) && <span className={styles.errorText}>{phoneError}</span>}
                  </div>

                  <div className={styles.formField}>
                    <label className={styles.fieldLabel}>{t('setting_account.field_name')}</label>
                    <input className={styles.input} value={name || ""} onChange={(e) => handleChange("name", e.target.value)} />
                    {!_.isEmpty(nameError) && <span className={styles.errorText}>{nameError}</span>}
                  </div>

                  <div className={styles.formField}>
                    <label className={styles.fieldLabel}>{t('setting_account.field_email')} <span className={styles.req}>*</span></label>
                    <input className={styles.input} type="email" value={email || ""} onChange={(e) => handleChange("email", e.target.value)} />
                    {!_.isEmpty(emailError) && <span className={styles.errorText}>{emailError}</span>}
                  </div>

                  <div className={styles.formField}>
                    <label className={styles.fieldLabel}>{t('setting_account.field_company')}</label>
                    <input className={styles.input} value={company || ""} onChange={(e) => handleChange("company", e.target.value)} />
                  </div>

                  <div className={styles.formField}>
                    <label className={styles.fieldLabel}>{t('setting_account.field_country')} <span className={styles.req}>*</span></label>
                    <select
                      className={styles.input}
                      value={country || ''}
                      onChange={(e) => handleChange('country', e.target.value)}
                    >
                      <option value="">{t('setting_account.select_country_placeholder')}</option>
                      {(countriesOnly || []).map((c) => (
                        <option key={c} value={c}>{c}</option>
                      ))}
                    </select>
                    {!_.isEmpty(countryError) && <span className={styles.errorText}>{countryError}</span>}
                  </div>

                  {country && country !== 'Other' && (
                    <div className={styles.formField}>
                      <label className={styles.fieldLabel}>{t('setting_account.field_province')}</label>
                      <select
                        className={styles.input}
                        value={typeof province === 'object' ? province?.provinceName : (province || '')}
                        onChange={(e) => handleChange('province', e.target.value)}
                      >
                        <option value="">{t('setting_account.select_province_placeholder')}</option>
                        {(providerOptions || []).map((p) => {
                          const val = p?.provinceName || p;
                          return <option key={val} value={val}>{val}</option>;
                        })}
                      </select>
                    </div>
                  )}

                  <div className={`${styles.formField} ${styles.full}`}>
                    <label className={styles.fieldLabel}>{t('setting_account.field_business')}</label>
                    <div className={styles.tagBox} onClick={() => document.getElementById('bizInput').focus()}>
                      {user_business.map((b) => b && (
                        <span key={b.id} className={styles.tagItem}>
                          {b.name}
                          <button
                            className={styles.tagX}
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleChange('business', user_business.filter((x) => x.id !== b.id));
                            }}
                          >✕</button>
                        </span>
                      ))}
                      <input
                        id="bizInput"
                        className={styles.tagAdd}
                        value={businessInput}
                        onChange={(e) => setBusinessInput(e.target.value)}
                        placeholder={user_business.length === 0 ? t('setting_account.business_input_placeholder') : ''}
                        list="biz-options"
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' && businessInput.trim()) {
                            e.preventDefault();
                            const found = (whatYouNeed?.business || []).find(
                              (b) => b.name.toLowerCase() === businessInput.trim().toLowerCase()
                            );
                            if (found && !user_business.find((b) => b.id === found.id)) {
                              handleChange('business', [...user_business, found]);
                            }
                            setBusinessInput('');
                          }
                          if (e.key === 'Backspace' && !businessInput && user_business.length > 0) {
                            handleChange('business', user_business.slice(0, -1));
                          }
                        }}
                      />
                      <datalist id="biz-options">
                        {(whatYouNeed?.business || [])
                          .filter((b) => !user_business.find((x) => x.id === b.id))
                          .map((b) => <option key={b.id} value={b.name} />)
                        }
                      </datalist>
                    </div>
                    <span className={styles.fieldHint}>{t('setting_account.business_hint')}</span>
                  </div>
                </div>

                {/* Save bar */}
                {isDirty && (
                  <div className={styles.saveBar}>
                    <span className={styles.saveBarTxt}>{t('setting_account.save_bar_unsaved')}</span>
                    <div className={styles.saveBarActions}>
                      <button className={styles.btn + ' ' + styles.btnGhostInverse} onClick={() => {
                        setName(user?.name); setPhone(user?.phone); setEmail(user?.email); setCompany(user?.company); setCountry(user?.country); setProvince(user?.province);
                      }}>{t('setting_account.save_bar_cancel')}</button>
                      <button className={styles.btn + ' ' + styles.btnPrimary} onClick={handleSubmitChangeInfo}>{t('setting_account.save_bar_save')}</button>
                    </div>
                  </div>
                )}
                
                {updateInfoSuccess && <div style={{color: 'var(--green-dark)', marginTop: 10}}>{updateInfoSuccess}</div>}
                {updateInfoError && <div style={{color: 'var(--red)', marginTop: 10}}>{updateInfoError}</div>}
              </div>
            </div>
          </section>
        )}

        {/* TAB 2: LIÊN KẾT */}
        {activeTab === 'linked' && (
          <section className={styles.tabPanel} id="panel-linked">
            <div className={styles.calloutInfo}>
              <svg viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6.5"/><path d="M8 7.5v3.5M8 5h.01"/></svg>
              <div className={styles.calloutInfoTxt} dangerouslySetInnerHTML={{ __html: t('setting_account.linked_callout') }} />
            </div>
            <div id="disconnect" className={styles.card}>
              <div className={styles.cardHd}>
                <div>
                  <div className={styles.cardHdTitle}>{t('setting_account.linked_card_title')} <span className={styles.tabCount}>{whatYouNeed?.users?.length || 0}</span></div>
                  <div className={styles.cardHdSub}>{t('setting_account.linked_card_sub')}</div>
                </div>
                <button id="add_acount" className={styles.btn + ' ' + styles.btnPrimary + ' ' + styles.btnSm} onClick={handleSubmitInviteCode}>
                  <svg viewBox="0 0 14 14"><path d="M7 2v10M2 7h10"/></svg> {t('setting_account.invite_member_btn')}
                </button>
              </div>
              <div style={{padding: '0 20px 20px'}}>
                <ListAccountComponent
                  handleInviteCode={() => handleSubmitInviteCode()}
                  data={whatYouNeed}
                  handleUnlink={(item) => handleUnlink(item)}
                  messageUnlink={messageUnlink}
                  messageInviteError={messageInviteError}
                  statusUnlink={unlink}
                  user={user}
                  handleOpenTransferConfirm={() => setIsShowConfirmTransfer(true)}
                  setTransferedId={setTransferedId}
                  handleOpenTransfer={() => setIsOpenTransfer(true)}
                />
              </div>
            </div>
          </section>
        )}

        {/* TAB 3: GÓI & GIAO DỊCH */}
        {activeTab === 'billing' && (
          <section className={styles.tabPanel} id="panel-billing">
            {/* Gói hiện tại */}
            <div className={styles.card}>
              <div className={styles.cardHd}><div className={styles.cardHdTitle}>{t('setting_account.billing_current_plan')}</div></div>
              <div className={styles.cardBd}>
                <div className={styles.planCardInner}>
                  <div className={styles.planLeft}>
                    <div className={styles.planIcon}>🔥</div>
                    <div>
                      <div className={styles.planName}>{whatYouNeed?.package?.type || user?.package_name || t('overall.account_info.lifetime')}</div>
                      <div className={styles.planSub}>
                        {t('setting_account.billing_expire')}: {whatYouNeed?.package?.expiredAt ? moment(whatYouNeed.package.expiredAt).format('DD/MM/YYYY') : t('setting_account.billing_lifetime_date')} · {t('setting_account.billing_no_limit')}
                      </div>
                    </div>
                  </div>
                  <div className={styles.heroStats} style={{borderLeft: 'none', paddingLeft: 0}}>
                    <div className={styles.heroStat}>
                      <div className={`${styles.heroStatVal} ${styles.inf}`}>{packageMsgLimit === -1 ? '∞' : (packageMsgLimit || '∞')}</div>
                      <div className={styles.heroStatLbl}>{t('setting_account.billing_stat_registered')}</div>
                    </div>
                    <div className={styles.heroStat}>
                      <div className={styles.heroStatVal}>{messageSentCalc.toLocaleString(locale)}</div>
                      <div className={styles.heroStatLbl}>{t('setting_account.stat_sent')}</div>
                    </div>
                    <div className={styles.heroStat}>
                      <div className={`${styles.heroStatVal} ${styles.inf}`}>{isUnlimitedMsgs ? '∞' : (totalMesRemain ?? 0).toLocaleString(locale)}</div>
                      <div className={styles.heroStatLbl}>{t('setting_account.stat_remain')}</div>
                    </div>
                  </div>
                  <button className={`${styles.btn} ${styles.btnOutline} ${styles.btnSm}`} onClick={() => window.open('https://bombot.vn/pricing', '_blank')}>
                    {t('setting_account.billing_view_plans')}
                  </button>
                </div>
              </div>
            </div>

            {/* Lịch sử giao dịch */}
            <div className={styles.card}>
              <div className={styles.cardHd}>
                <div>
                  <div className={styles.cardHdTitle}>{t('setting_account.billing_history_title')}</div>
                  <div className={styles.cardHdSub}>{t('setting_account.billing_history_sub')}</div>
                </div>
              </div>
              <div style={{padding: '0 20px 20px'}}>
                <ListHistoryComponent whatYouNeed={whatYouNeed} />
              </div>
            </div>
          </section>
        )}

        {/* TAB 4: ĐIỂM THƯỞNG */}
        {activeTab === 'rewards' && (
          <section className={styles.tabPanel} id="panel-rewards">
            <div className={styles.card}>
              <div className={styles.cardBd}>
                <div className={styles.pointsHero}>
                  <div className={styles.pointsRing} style={{'--pct': `${Math.min((rewardsMissionPoints / 200) * 100, 100)}`}}>
                    <div className={styles.pointsCenter}><b>{rewardsMissionPoints}</b><span>{t('setting_account.rewards_points_unit')}</span></div>
                  </div>
                  <div className={styles.pointsInfo}>
                    <div className={styles.pointsTitle}>{t('setting_account.rewards_more_points')}</div>
                    <div className={styles.pointsDesc}>{t('setting_account.rewards_desc')}</div>
                    <div className={styles.pointsProgressLbl}>
                      <span dangerouslySetInnerHTML={{ __html: t('setting_account.rewards_next_milestone') }} />
                      <span><b>{rewardsMissionPoints}</b> / 200 {t('setting_account.rewards_points_unit')}</span>
                    </div>
                    <div className={styles.progressTrack}>
                      <div className={styles.progressFill} style={{width: `${Math.min((rewardsMissionPoints / 200) * 100, 100)}%`}}></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.card}>
              <DialogPolicyPointContainer
                handleClose={handleCloseIsViewPolicyPoint}
                getOpenPoits={getOpenPoits}
                subTab={rewardSubTab}
              />
            </div>
          </section>
        )}

        {/* TAB 5: BẢO MẬT */}
        {activeTab === 'security' && (
          <section className={styles.tabPanel} id="panel-security">
            <div className={styles.grid2col}>
              <div className={styles.card}>
                <div className={styles.cardHd}>
                  <div>
                    <div className={styles.cardHdTitle}>{t('setting_account.security_change_pw_title')}</div>
                    <div className={styles.cardHdSub}>{t('setting_account.security_change_pw_sub')}</div>
                  </div>
                </div>
                <div className={styles.cardBd}>
                  <div className={styles.formGrid} style={{gridTemplateColumns: '1fr'}}>
                    {!user.noPwSet && (
                      <div className={styles.formField}>
                        <label className={styles.fieldLabel}>{t('setting_account.field_pw_current')} <span className={styles.req}>*</span></label>
                        <div className={styles.inputWrap}>
                          <input className={styles.input} type={showPwOld ? "text" : "password"} value={passwordOld || ""} onChange={(e) => handleChangePassword("passwordOld", e.target.value)} placeholder={t('setting_account.pw_placeholder_current')} />
                          <button className={styles.inputiconbtn} onClick={() => setShowPwOld(!showPwOld)}>
                            <svg viewBox="0 0 16 16" fill="none"><path d="M1.5 8s2.5-4.5 6.5-4.5S14.5 8 14.5 8s-2.5 4.5-6.5 4.5S1.5 8 1.5 8z"/><circle cx="8" cy="8" r="2"/></svg>
                          </button>
                        </div>
                      </div>
                    )}
                    <div className={styles.formField}>
                      <label className={styles.fieldLabel}>{t('setting_account.field_pw_new')} <span className={styles.req}>*</span></label>
                      <div className={styles.inputWrap}>
                        <input className={styles.input} type={showPwNew ? "text" : "password"} value={passwordNew || ""} onChange={(e) => handleChangePassword("passwordNew", e.target.value)} placeholder={t('setting_account.pw_placeholder_new')} />
                        <button className={styles.inputiconbtn} onClick={() => setShowPwNew(!showPwNew)}>
                          <svg viewBox="0 0 16 16" fill="none"><path d="M1.5 8s2.5-4.5 6.5-4.5S14.5 8 14.5 8s-2.5 4.5-6.5 4.5S1.5 8 1.5 8z"/><circle cx="8" cy="8" r="2"/></svg>
                        </button>
                      </div>
                      <div className={styles.strengthTrack}>
                        {[1, 2, 3].map((i) => (
                          <div key={i} className={`${styles.strengthSeg} ${i <= passwordStrength ? strengthClasses[passwordStrength] : ''}`}></div>
                        ))}
                      </div>
                      <div className={styles.strengthLbl}>{strengthLabels[passwordStrength]}</div>
                    </div>
                    <div className={styles.formField}>
                      <label className={styles.fieldLabel}>{t('setting_account.field_pw_confirm')} <span className={styles.req}>*</span></label>
                      <div className={styles.inputWrap}>
                        <input className={styles.input} type={showPwNew2 ? "text" : "password"} value={passwordNew2 || ""} onChange={(e) => handleChangePassword("passwordNew2", e.target.value)} placeholder={t('setting_account.pw_placeholder_confirm')} />
                        <button className={styles.inputiconbtn} onClick={() => setShowPwNew2(!showPwNew2)}>
                          <svg viewBox="0 0 16 16" fill="none"><path d="M1.5 8s2.5-4.5 6.5-4.5S14.5 8 14.5 8s-2.5 4.5-6.5 4.5S1.5 8 1.5 8z"/><circle cx="8" cy="8" r="2"/></svg>
                        </button>
                      </div>
                      {passwordNew2 && passwordNew !== passwordNew2 && (
                        <span className={styles.fieldHint} style={{color: 'var(--red)'}}>{t('setting_account.pw_mismatch')}</span>
                      )}
                    </div>
                    
                    {isSubmitChangePassword && !_.isEmpty(errorPassword) && (
                      <div style={{color: 'var(--red)', fontSize: '13px', marginTop: '10px'}}>{errorPassword}</div>
                    )}

                    <div style={{marginTop: '15px'}}>
                      <button 
                        className={styles.btn + ' ' + styles.btnPrimary} 
                        disabled={(!user.noPwSet && !passwordOld) || passwordNew.length < 8 || passwordNew !== passwordNew2}
                        onClick={handleSubmitChangePassword}
                      >
                      {t('setting_account.pw_update_btn')}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                {(whatYouNeed?.version || share?.version) && (
                  <div className={styles.card}>
                    <div className={styles.cardHd}><div className={styles.cardHdTitle}>{t('setting_account.version_title')}</div></div>
                    <div className={styles.cardBd}>
                      <div className={styles.versionRow}>
                        <div className={styles.versionIcon}>
                          <svg viewBox="0 0 18 18" fill="none"><rect x="2" y="2" width="14" height="14" rx="3"/><path d="M6 9l2 2 4-4" stroke="currentColor" strokeWidth="2"/></svg>
                        </div>
                        <div style={{flex:1, minWidth:0}}>
                          <div className={styles.versionNum}>
                            Version {(whatYouNeed?.version?.id) || (share?.version?.id) || ''}
                            <span className={styles.badgeLatest}>{t('setting_account.version_latest_badge')}</span>
                          </div>
                          {(whatYouNeed?.version?.updatedAt || share?.version?.updatedAt) && (
                            <div className={styles.versionSub}>
                              {t('setting_account.version_updated_on', { date: moment(whatYouNeed?.version?.updatedAt || share?.version?.updatedAt).format('DD/MM/YYYY') })}
                            </div>
                          )}
                        </div>
                      </div>
                      {(whatYouNeed?.version || share?.version) && (
                        <div style={{marginTop: '12px'}}>
                          <button
                            className={styles.linkMore}
                            onClick={() => setIsVersionPopup(true)}
                          >
                            {t('setting_account.version_view_detail')}
                            <svg viewBox="0 0 12 12" fill="none"><path d="M4.5 2.5l4 3.5-4 3.5"/></svg>
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                )}
                <div className={styles.card}>
                  <div className={styles.cardHd}><div className={styles.cardHdTitle}>{t('setting_account.session_title')}</div></div>
                  <div className={styles.cardBd}>
                    <div className={styles.sessionItem}>
                      <div className={styles.sessionIcon}>💻</div>
                      <div className={styles.sessionInfo}>
                        <div className={styles.sessionName}>
                          {(() => {
                            const ua = navigator.userAgent
                            const browser = ua.includes('CocCoc') ? 'Cốc Cốc'
                              : ua.includes('Edg') ? 'Edge'
                              : ua.includes('OPR') || ua.includes('Opera') ? 'Opera'
                              : ua.includes('Brave') ? 'Brave'
                              : ua.includes('Chrome') ? 'Chrome'
                              : ua.includes('Firefox') ? 'Firefox'
                              : ua.includes('Safari') ? 'Safari'
                              : 'Browser'
                            const os = ua.includes('Windows') ? 'Windows'
                              : ua.includes('Mac') ? 'macOS'
                              : ua.includes('Linux') ? 'Linux'
                              : ua.includes('Android') ? 'Android'
                              : ua.includes('iPhone') || ua.includes('iPad') ? 'iOS'
                              : 'Unknown'
                            return `${browser} · ${os}`
                          })()}
                          <span className={styles.badgeRole}>{t('setting_account.session_current_badge')}</span>
                        </div>
                        <div className={styles.sessionSub}>
                          {[user?.province, user?.country].filter(Boolean).join(', ')}
                          {(user?.province || user?.country) ? ' · ' : ''}
                          {t('setting_account.session_last_login', { datetime: user?.lastLogin ? moment(user.lastLogin).format('DD/MM/YYYY HH:mm') : new Date().toLocaleDateString(locale) })}
                        </div>
                      </div>
                    </div>
                    <button
                      className={`${styles.btn} ${styles.btnDangerSoft} ${styles.btnSm}`}
                      style={{marginTop: '14px'}}
                      onClick={() => accountApi.logout()}
                    >
                      {t('setting_account.session_logout_btn')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}


      </div>



      {/* ── REWARDS POPUP ── */}
      {isRewardsPopup && (
        <div className={`${styles.modalOverlay} ${styles.show}`} onClick={() => setIsRewardsPopup(false)}>
          <div className={`${styles.modal} ${styles.rewardsModal}`} onClick={e => e.stopPropagation()}>

            {/* Close */}
            <button className={styles.rewardsModalX} onClick={() => setIsRewardsPopup(false)}>
              <svg viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6l12 12" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </button>

            {/* Hero */}
            <div className={styles.rewardsHero}>
              {/* gift badge with sparkles */}
              <div className={styles.rewardsGiftIcon}>
                <svg viewBox="0 0 24 24" fill="none">
                  <path d="M20 12v9H4v-9M2 7h20v5H2V7zm10 14V7m0 0C10.5 3.5 6 3 6 6.5S9.5 7 12 7zm0 0c1.5-3.5 6-4 6-.5S14.5 7 12 7z" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span className={styles.sparkleTopLeft}>✦</span>
                <span className={styles.sparkleBottomLeft}>✦</span>
              </div>

              <div className={styles.rewardsHeroLabel}>{t('setting_account.rewards_popup_title')}</div>
              <h2 className={styles.rewardsHeroCongrats}>{t('setting_account.rewards_popup_congrats', { name: user?.name })}</h2>
              <p className={styles.rewardsHeroDesc}>
                {t('setting_account.rewards_popup_desc_pre')}<b>{t('setting_account.rewards_popup_desc_bold')}</b>{t('setting_account.rewards_popup_desc_post')}
              </p>
              <div className={styles.rewardsLimitedBadge}>
                <svg viewBox="0 0 24 24" fill="none">
                  <path d="M12 2l2.4 6.6L21 11l-6.6 2.4L12 20l-2.4-6.6L3 11l6.6-2.4L12 2z"/>
                </svg>
                {t('setting_account.rewards_popup_limited')}
              </div>
            </div>

            {/* Points card */}
            <div className={styles.rewardsPtsCard}>
              <div className={styles.rewardsPtsCardLeft}>
                <div className={styles.rewardsPtsLbl}>{t('setting_account.rewards_popup_pts_label')}</div>
                <div className={styles.rewardsPtsVal}>
                  <span className={styles.rewardsPtsNum}>{rewardsMissionPoints}</span>
                  <span className={styles.rewardsPtsUnit}>{t('setting_account.rewards_points_unit')}</span>
                </div>
              </div>
              <div className={styles.rewardsEligible}>
                {t('setting_account.rewards_popup_eligible')}
                <svg viewBox="0 0 24 24" fill="none"><path d="M20 6L9 17l-5-5" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </div>
            </div>

            {/* Tip / missions */}
            <div className={styles.rewardsMissionsBox}>
              <div className={styles.rewardsMissionsHint}>
                <svg viewBox="0 0 24 24" fill="none">
                  <path d="M9 18h6M10 22h4M12 2a6 6 0 00-4 10.4c.6.5 1 1.3 1 2.1V16h6v-1.5c0-.8.4-1.6 1-2.1A6 6 0 0012 2z" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                {t('setting_account.rewards_popup_daily_hint')}
              </div>
              {getMappedMissions(missions).slice(0, 2).map((mission) => (
                <div key={mission.id} className={styles.rewardsMissionItem}>
                  <span className={styles.rewardsMissionName}>{t(MISSION_LABEL_KEYS[mission.id])}</span>
                  <span className={styles.rewardsMissionBadge}>{`+${Number(mission.points) || 0}`}</span>
                </div>
              ))}
              <button
                className={styles.rewardsViewAll}
                onClick={() => {
                  setIsRewardsPopup(false);
                  setActiveTab('rewards');
                  setRewardSubTab('missions');
                }}
              >
                {t('setting_account.rewards_popup_view_all')}
                <svg viewBox="0 0 24 24" fill="none"><path d="M9 18l6-6-6-6" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </button>
            </div>

            {/* Footer */}
            <div className={styles.rewardsCta}>
              <button
                className={styles.rewardsRedeemBtn}
                onClick={() => {
                  setIsRewardsPopup(false);
                  setActiveTab('rewards');
                  setRewardSubTab('redeem');
                  setTimeout(() => {
                    const el = document.getElementById('rewardSegGroup');
                    if (el) {
                      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                  }, 100);
                }}
              >
                {t('setting_account.rewards_popup_redeem_btn')}
                <svg viewBox="0 0 24 24" fill="none"><path d="M5 12h14M13 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </button>
              <button className={styles.rewardsLaterBtn} onClick={() => setIsRewardsPopup(false)}>
                {t('setting_account.rewards_popup_later_btn')}
              </button>
              <div className={styles.rewardsNote}>{t('setting_account.rewards_popup_note')}</div>
            </div>

          </div>
        </div>
      )}

      {/* ── INVITE MODAL ── */}
      {isInviteCodePopup && (
        <div className={`${styles.modalOverlay} ${styles.show}`} onClick={handleCloseInviteCodePopup}>
          <div className={styles.modal} onClick={e => e.stopPropagation()}>
            <div className={styles.modalHd}>
              <span className={styles.modalTitle}>{t('setting_account.invite_modal_title')}</span>
              <button className={styles.modalX} onClick={handleCloseInviteCodePopup}>✕</button>
            </div>
            <div className={styles.modalBd}>
              <p className={styles.modalDesc}>
                {t('setting_account.invite_modal_desc')}
              </p>
              <div className={styles.inviteLinkRow}>
                <input className={styles.input} value={inviteCodeData} readOnly ref={textAreaRef} />
                <button className={`${styles.btn} ${styles.btnPrimary} ${styles.btnSm}`} onClick={copyToClipboard}>
                  <svg viewBox="0 0 12 12" fill="none"><rect x="3" y="3" width="7" height="7" rx="1"/><path d="M2 8V2h6"/></svg>
                  {t('setting_account.invite_copy_btn')}
                </button>
              </div>
              {copySuccess && <p style={{fontSize: '11.5px', color: 'var(--green-dark)', marginTop: 8}}>{copySuccess}</p>}
              <p style={{fontSize: '11px', color: 'var(--text-tertiary)', marginTop: 10}}>
                {t('setting_account.invite_link_note')}
              </p>
            </div>
          </div>
        </div>
      )}

      {/* ── TRANSFER MODAL ── */}
      {isOpenTransfer && (
        <div className={`${styles.modalOverlay} ${styles.show}`} onClick={() => setIsOpenTransfer(false)}>
          <div className={`${styles.modal} ${styles.modalLg}`} onClick={e => e.stopPropagation()}>
            <div className={styles.modalHd}>
              <span className={styles.modalTitle}>{t('setting_account.transfer_modal_title')}</span>
              <button className={styles.modalX} onClick={() => setIsOpenTransfer(false)}>✕</button>
            </div>
            <div className={styles.modalBd}>

              {/* Before / After compare */}
              <div className={styles.transferCompare}>
                <div className={styles.transferSide}>
                  <div className={styles.transferSideAvatar} style={{ background: avatarColor(user?.name) }}>
                    {user?.name?.charAt(0)?.toUpperCase() || 'U'}
                  </div>
                  <div className={styles.transferSideName}>{user?.name}</div>
                  <div className={styles.transferSideRole}>{t('setting_account.transfer_role_from')}</div>
                </div>

                {/* Arrow */}
                <div className={styles.transferArrow}>
                  <svg viewBox="0 0 20 20" fill="none" style={{ width: 20, height: 20, stroke: '#9CA3AF', strokeWidth: 2 }}>
                    <path d="M5 10h10M11 6l4 4-4 4" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>

                <div className={`${styles.transferSide} ${styles.to}`}>
                  <div className={styles.transferSideAvatar} style={{ background: avatarColor(transferedAccount?.name || 'H') }}>
                    {transferedAccount?.name?.charAt(0)?.toUpperCase() || 'H'}
                  </div>
                  <div className={styles.transferSideName}>{transferedAccount?.name || '—'}</div>
                  <div className={`${styles.transferSideRole} ${styles.toRole}`}>{t('setting_account.transfer_role_to')}</div>
                </div>
              </div>

              {/* Cảnh báo */}
              <div className={styles.warnList}>
                <p dangerouslySetInnerHTML={{ __html: `<b>${t('setting_account.transfer_warn_irrev')}</b>` }} />
                <ul>
                  <li dangerouslySetInnerHTML={{ __html: t('setting_account.transfer_warn_1') }} />
                  <li dangerouslySetInnerHTML={{ __html: t('setting_account.transfer_warn_2') }} />
                  <li dangerouslySetInnerHTML={{ __html: t('setting_account.transfer_warn_3') }} />
                  <li dangerouslySetInnerHTML={{ __html: t('setting_account.transfer_warn_4') }} />
                </ul>
              </div>

              {/* Confirm input */}
              <label className={styles.confirmLabel} dangerouslySetInnerHTML={{ __html: t('setting_account.transfer_confirm_label') }} />
              <input
                className={styles.input}
                value={confirmTransferText}
                onChange={e => setConfirmTransferText(e.target.value)}
                placeholder={TRANSFER_KEYWORD}
              />
            </div>

            <div className={styles.modalFt}>
              <button
                className={`${styles.btn} ${styles.btnOutline}`}
                onClick={() => { setIsOpenTransfer(false); setConfirmTransferText(''); }}
              >
                {t('setting_account.transfer_cancel_btn')}
              </button>
              <button
                className={`${styles.btn} ${styles.btnDanger}`}
                disabled={confirmTransferText !== TRANSFER_KEYWORD}
                onClick={() => { setIsShowConfirmTransfer(true); setIsOpenTransfer(false); }}
                style={confirmTransferText !== TRANSFER_KEYWORD ? { background: '#FCA5A5', cursor: 'not-allowed', opacity: 1 } : {}}
              >
                {t('setting_account.transfer_confirm_btn')}
              </button>
            </div>
          </div>
        </div>
      )}

      <ModalConfirm
        content={t('setting_account.transfer_modal_confirm', { from: currentUserDisplay, to: transferedDisplay })}
        onClose={() => setIsShowConfirmTransfer(false)}
        isOpen={isShowConfirmTransfer}
        onConfirm={handleTransferAccount}
      />

      {/* ── VERSION POPUP ── */}
      {isVersionPopup && (() => {
        const vObj = whatYouNeed?.version || share?.version
        if (!vObj) return null
        const lang = typeof i18n?.language === 'string' ? i18n.language.substring(0, 2) : 'vi'
        const vHtml = lang === 'en' ? (vObj.contentEn || vObj.content)
          : lang === 'kh' ? (vObj.contentKh || vObj.content)
          : vObj.content || ''
        return (
          <div className={`${styles.modalOverlay} ${styles.show}`} onClick={() => setIsVersionPopup(false)}>
            <div className={`${styles.modal} ${styles.modalLg}`} onClick={e => e.stopPropagation()}>
              {/* Header */}
              <div className={styles.modalHd}>
                <div>
                  <div className={styles.modalTitle}>Version {vObj.id}</div>
                  {vObj.updatedAt && (
                    <div style={{fontSize: 11.5, color: 'var(--text-tertiary)', marginTop: 2}}>
                      {t('setting_account.version_updated_on', { date: moment(vObj.updatedAt).format('DD/MM/YYYY') })}
                    </div>
                  )}
                </div>
                <button className={styles.modalX} onClick={() => setIsVersionPopup(false)}>✕</button>
              </div>

              {/* Body — HTML content */}
              <div className={styles.modalBd}>
                {vHtml
                  ? <div className={styles.versionContent} dangerouslySetInnerHTML={{ __html: vHtml }} />
                  : <p style={{color: 'var(--text-tertiary)'}}>{t('setting_account.version_no_detail')}</p>
                }
              </div>

              {/* Footer */}
              <div className={styles.modalFt}>
                <button className={`${styles.btn} ${styles.btnPrimary}`} onClick={() => setIsVersionPopup(false)}>
                  {t('setting_account.version_understood')}
                </button>
              </div>
            </div>
          </div>
        )
      })()}
      <MessengerButton />
    </MainLayout>
  )
}

export default SettingAccountView

